import _sfc_main from "./Message.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("Transition", { attrs: { "name": "message" } }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.isShow, expression: "isShow" }], ref: "messageRef", class: ["t-message", `t-message-${_setup.props.type}`], style: {
    top: _setup.props.top,
    zIndex: _setup.props.zIndex
  } }, [_c(_setup.SvgIcon, { staticClass: "t-message-icon", attrs: { "icon": _setup.svgName } }), _c("span", { staticClass: "t-message-text" }, [_vm._v(_vm._s(_setup.props.message))])], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "769d2e00"
);
const Message = __component__.exports;
export {
  Message as default
};
